const CoreConstant = angular.module('umCore')
    .constant('coreConstant', {
        event: {
            BOOT_APPLICATION: 'coreModule.bootApplication',
            ADVANCE_FOCUS: 'coreModule.advanceFocus',
            INVALID_SESSION: 'coreModule.invalidSession',
            RECENT_ACTIVITIES_CHANGED: 'coreModule.recentActivitiesChanged',
            DATAGRID_ON_STARTUP_COMPLETE: 'ums:datagrid:onStartupComplete',
            DATAGRID_ON_RESET_HEADERS: 'ums:datagrid:onResetHeaders',
            KEEPALIVE_PING: 'ums:keepalive:ping',
            STOP_KEEPALIVE_PING: 'ums:stop:keepalive:ping',
            HANDLE_ERROR: 'Notification.handleError',
            SHOW_MODAL_NOTIFICATION: 'Notification.showModalNotification',
            SHOW_FADING_NOTIFICATION: 'Notification.showFadingNotification',
            SHOW_FADING_NOTIFICATION_LOADING_BAR: 'Notification.showFadingNotificationLoadingBar',
            CONCLUDE_FADING_NOTIFICATION_LOADING_BAR: 'Notification.concludeFadingNotificationLoadingBar',
            SHOW_EMAIL_MODAL_NOTIFICATION: 'Notification.showEmailModalNotification',
            HANDLE_EMAIL_FROM_BUSINESS_CARD: 'Notification.showEmailFromBusinessCard',
            SHOW_EMAIL_EDITOR: 'Notification.showEmailEditor',
            SHOW_ERROR: 'Notification.showError',
            CONFIRM_ACTION_YES: 'Confirm.actionConfirmYes',
            CONFIRM_ACTION_NO: 'Confirm.actionConfirmNo',
            UPDATE_SUBMISSION: 'PersistentConnection.UpdateSubmission',
            UPDATE_NAVIGATION_ITEM_MESSAGE: 'PersistentConnection.UpdateNavigationItem',
            SHOW_LONG_REQUEST_WARNING: 'PersistentConnection.ShowLongRequestWarning',
            HIDE_LONG_REQUEST_WARNING: 'PersistentConnection.HideLongRequestWarning',
            REFRESH_QUOTE: 'PersistentConnection.RefreshQuote',
            REFRESH_POLICY_CHANGE: 'PersistentConnection.RefreshPolicyChange',
            QUOTE_DELETED: 'Submission.QuoteDeleted',
            REFRESH_PROPOSAL: 'PersistentConnection.RefreshProposal',
            PROPOSAL_DELETED: 'PersistentConnection.ProposalDeleted',
            REFRESH_RECENT_SUBMISSION_DROPDOWN: 'Submission.RefreshRecentSubmissionDropdown',
            CLOSE_SUBMISSION_VIEW: 'Submission.CloseSubmissionView',
            ACORD_UPLOAD_NOTIFICATION: 'AcordUploadNotification',
            PREFERENCES_READY: 'coreModule.PreferenceReady',
            USERTYPE_UPDATED: 'coreModule.UsertypeUpdated',
            START_UI_PERFORMANCE_LOG: 'coreModule.StartUiPerformanceLog',
            END_UI_PERFORMANCE_LOG: 'coreModule.EndUiPerformanceLog',
            END_UI_PERFORMANCE_LOG_WITHOUT_LOGGING: 'coreModule.EndUiPerformanceLogWithoutLogging',
            LOAD_SUBMISSION_LIST: 'coreModule.LoadSubmissionList',
            START_IDLE: 'coreModule.startIdle',
            STOP_IDLE: 'coreModule.stopIdle',
            LOGOUT_COMPLETE: 'coreModule.logoutComplete',
            FILE_DROPPED: 'coreModule.fileDropped',
            MODAL_OPENED: 'coreModule.modalOpen',
            MODAL_CLOSED: 'coreModule.modalClosed',
            MODAL_CLOSING: 'modal.closing',
            REFERESH_USER_NAME: 'refereshUserName',
            START_MAKING_APPLICATION: 'coreModule.StartMakingApplication',
            SHOW_USER_BUSINESS_CARD: 'showBusinessCard',
            HIDE_BUSINESS_CARD: 'hideBusinessCard',
            SHOW_ORGANIZATION_CARD: 'showOrganizationCard',
            HIDE_BUSINESS_CARD_ON_DROPDOWN: 'hideBusinessCardOnDropdown',
            PEOPLE_PICKER_USER_SELECTED: 'peoplePickerUserSelected',
            SHOW_LOADING_BAR: 'coreModule.showLoadingBar',
            HIDE_LOADING_BAR: 'coreModule.hideLoadingBar',
            HIDE_FADING_NOTIFICATION_LOADING_BAR: 'coreModule.hideFadingNotificationLoadingBar',
            EXPIRED_PASSWORD: 'coreModule.expiredPassword',
            NAVIGATION_DRAWER_TOGGLED: 'UiDrawerSlideDirective.DoneAnimating',
            APPLICATION_READY: 'coreModule.applicationReady',
            FILTER_SAVED: 'coreModule.filterSaved',
            FILTER_UPDATED: 'coreModule.filterUpdated',
            FILTER_CLEARED: 'coreModule.filterCleared',
            USER_AVATAR_RELOAD: 'userAvatarReload',
            UPDATE_SESSION_COUNTDOWN_MESSAGE: 'SessionTimeout.UPDATE_SESSION_COUNTDOWN_MESSAGE',
            SUBMISSION_FILTER_CHANGED: 'coreModule.submissionFilterChanged',
            FILTER_CHANGED: 'coreModule.filterChanged',
            GRID_SORT_TYPE_CHANGED: 'coreModule.gridSortTypeChanged',
            CREATE_NOTIFICATION: 'coreModule.notification.create',
            UPDATE_NOTIFICATION: 'coreModule.notification.update',
            CREATE_APP_NOTIFICATION: 'coreModule.notification.app.create',
            UPDATE_DATA_SET: 'coreModule.UpdateDataSet',
            SCROLL_TO_ITEM: 'Submission.ScrollToItem',
            SCROLL_TO_BOTTOM: 'Submission.ScrollToBottom',
            UPDATE_ACTIONS_MESSAGE: 'coreModule.UpdateActionsMessage',
            CHAT_VISIBILITY_CHANGED: 'coreModule.ChatVisibilityChanged',
            RESET_GRID_PAGING: 'coreModule.resetGridPaging',
            RECALCULATE_GRID_PAGING: 'coreModule.recalculateGridPaging',
            MULTI_SELECT_CLOSED: 'coreModule.MultiSelectClosed',
            MULTI_SELECT_UPDATED: 'coreModule.MultiSelectUpdated',
            MULTI_SELECT_FILTER_CHANGED: 'coreModule.MultiSelectFilterChanged',
            MULTI_SELECT_LIST_UPDATED: 'coreModule.MultiSelectListUpdated',
            SHOW_MULTI_SELECT_LIST_UPDATED: 'coreModule.ShowMultiSelectListUpdated',
            REFRESH_MULTI_SELECT: 'coreModule.RefreshMultiSelect',
            MULTI_SELECT_BUTTON_LABEL_UPDATED: 'coreModule.MultiSelectButtonLabelUpdated',
            RELOAD_CLASS_CODE_MULTI_SELECT: 'coreModule.ReloadClassCodeMultiSelect',
            MULTI_SELECT_CLEAR: 'coreModule.MultiSelectClear',
            SHOW_MULTI_SELECT: 'coreModule.ShowMultiSelect',
            HIDE_MULTI_SELECT: 'coreModule.HideMultiSelect',
            CREATE_USER: 'coreModule.createUser',
            UPDATE_USER: 'coreModule.updateUser',
            DELETE_USER: 'coreModule.deleteUser',
            RELOAD_USER: 'coreModule.reloadUser',
            CREATE_ORGANIZATION: 'coreModule.CreateOrganization',
            UPDATE_ORGANIZATION: 'coreModule.UpdateOrganization',
            DELETE_ORGANIZATION: 'coreModule.DeleteOrganization',
            ACCORDION_BUTTON_OPENED: 'coreModule.accordionButtonOpened',
            CLOSE_ACCORDION_BUTTON: 'coreModule.closeAccordionButton',
            OPEN_ACCORDION_BUTTON: 'coreModule.openAccordionButton',
            COLLAPSIBLE_LEFT_NAV_OPENED: 'coreModule.collapsibleLeftNavOpened',
            COLLAPSIBLE_LEFT_NAV_CLOSED: 'coreModule.collapsibleLeftNavClosed',
            SHOW_FORM_TOOLTIP: 'submission.showFormTooltip',
            HIDE_FORM_TOOLTIP: 'submission.hideFormTooltip',
            ACTION_BUTTONS_PROCESSING_COMPLETED: 'coreModule.ActionButtonsProcessingCompleted',
            FILE_UPLOADED: 'coreModule.fileUploaded',
            ACTION_STARTED: 'coreModule.ActionStarted',
            RELOAD_ACTIONS: 'coreModule.ReloadActions',
            CLOSE_EMAIL_POPUP: 'coreModule.closeEmailPopUp',
            ATTACHMENT_UPDATED: 'coreModule.attachmentUpdated',
            USER_GROUP_UPDATED: 'coreModule.userGroupUpdated',
            USER_GROUP_EDITOR_MODEL_UPDATED: 'coreModule.userGroupEditorModelUpdated',
            REFRESH_DATE_RANGE: 'coreModule.refreshDateRange',
            SHOW_TRANSACTION_TOOLTIP_EVENT: 'showTransactionTooltipEvent',
            HIDE_TRANSACTION_TOOLTIP_EVENT: 'hideTransactionTooltipEvent',
            SHOW_CUSTOM_ALERT_MODAL_NOTIFICATION: 'Notification.showCustomAlertModalNotification',
            widget: {
                DRAG_START: 'coreModule.widgetDragStart',
                DRAG_STOP: 'coreModule.widgetDragStop',
                RESIZE_START: 'coreModule.widgetResizeStart',
                RESIZE_STOP: 'coreModule.widgetResizeStop',
                RESIZED: 'coreModule.widgetResized'
            },
            dropdown: {
                DROPDOWN_ITEM_CHANGED: 'coreModule.dropdownItemChanged',
                DROPDOWN_HIGHLIGHT_UP: 'coreModule.dropdownHighlightUp',
                DROPDOWN_HIGHLIGHT_DOWN: 'coreModule.dropdownHighlightDown',
                DROPDOWN_SELECT_HIGHLIGHTED_ITEM: 'coreModule.dropdownSelectHighlightedItem',
                DROPDOWN_CLEAR_SEARCH_INPUT: 'coreModules.dropdownClearSearchInput',
                DROPDOWN_CLEAR_SELECTED: 'coreModules.dropdownClearSelected',
                DROPDOWN_CLOSE: 'coreModules.dropdownClose',
                searchInterface: {
                    FOCUS_CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownSearchInterfaceFocusClearSearchInputButton',
                    BLUR_CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownSearchInterfaceBlurClearSearchInputButton',
                    FOCUS_CLEAR_SELECTED_BUTTON: 'coreModule.dropdownSearchInterfaceFocusClearSelectedButton',
                    BLUR_CLEAR_SELECTED_BUTTON: 'coreModule.dropdownSearchInterfaceBlurClearSelectedButton',
                }
            },
            classCode: {
                HIDE_TOOLTIP: 'coreModule.hideTooltip',
            },
            functionExecute: 'coreModule.functionExecute',
            gridSelectionChanged: 'coreModule.gridSelectionChanged'
        },
        uiPeformanceLogger: {
            SUCCESS: 'success',
            FAIL: 'fail'
        },
        authorization: {
            LOCAL_STORAGE_LOGIN_TOKEN_KEY: 'loginToken',
            SESSION_STORAGE_CLIENT_ID_KEY: 'clientId',
            SCHEME: 'UMS-TOKEN',
            INITIAL_TOKEN_TIMEOUT_SECONDS: 60*60, // 1 hour
            CONSOLE_TYPE_UM: 'um',
            CONSOLE_TYPE_UM_AGENT: 'umagent',
            CONSOLE_TYPE_UM_STUDIO: 'umstudio',
            CONSOLE_TYPE_APPREADER: 'appreader'
        },
        CONTEXT_NONE: 'ContextNone',
        EDGE_KEEP_ALIVE_PING_INTERVAL: 5000,
        DEFAULT_KEEP_ALIVE_PING_INTERVAL: 60000,
        DEFAULT_REFRESH_LOGIN_TOKEN_INTERVAL: 900000,
        DEFAULT_SERVER_DISCONNECTED_RECONNECT_INTERVAL: 10000,
        SERVER_DISCONNECTED_TRIES_BEFORE_ADDITIONAL_INFO: 3,
        dropdown: {
            searchInterface: {
                SEARCH_INPUT: 'coreModule.dropdownSearchInputActiveSearchInterface',
                CLEAR_SEARCH_INPUT_BUTTON: 'coreModule.dropdownClearSearchInputButtonActiveSearchInterface',
                CLEAR_SELECTED_BUTTON: 'coreModule.dropdownClearSelectedButtonActiveSearchInterface'
            }
        },
        notifications: {
            loadLimit: 25,
            filters: {
                ALL: 'all',
                UNREAD: 'unread'
            }
        },
        chatNotifications: {
            loadLimit: 25,
            filters: {
                ALL: 'all',
                UNREAD: 'unread'
            }
        }
    });
